import { useRef, useState } from "react";
import Compressor from "compressorjs";
import { v4 as uuidv4 } from "uuid";

export default () => {
  const getDownscaledDimensions = (file) => {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.onload = () => {
        const width = img.width;
        const height = img.height;
        const aspectRatio = width / height;

        const isSquare = width === height;
        const isVertical = height > width;

        const minSize = isSquare ? 120 : isVertical ? 240 : 426;
        const sizes = [];
        sizes.push([width, height]);
        let newWidth = width;
        let newHeight = height;

        while (newWidth > minSize && newHeight > minSize) {
          newWidth = Math.round(newWidth / 1.5);
          newHeight = Math.round(newWidth / aspectRatio);
          sizes.push([newWidth, newHeight]);
        }

        resolve(sizes);
      };
      img.onerror = reject;
      img.src = URL.createObjectURL(file);
    });
  };

  /**
   *
   * @param {*} file
   * @returns {Promise<{dimensions: {width: number, height: number}, blob: File | Blob, fileName: string}[]>}
   */
  const compress = async (file) => {
    const _dimensions = await getDownscaledDimensions(file);
    const compressedImages = await Promise.all(
      _dimensions.map(
        ([width, height], index) =>
          new Promise((resolve, reject) => {
            new Compressor(file, {
              quality: 0.7,
              maxWidth: width,
              maxHeight: height,
              success: (blob) =>
                resolve({
                  dimensions: { width, height },
                  blob,
                  fileName: `${uuidv4()}.${file?.name?.split(".")?.pop()}`,
                }),
              error: reject,
            });
          })
      )
    );

    return compressedImages;
  };

  const findClosestMatch = (dimensionArray, elementRef) => {
    if (
      !elementRef?.current ||
      !dimensionArray ||
      dimensionArray.length === 0 ||
      dimensionArray?.some(({ dimensions }) => !dimensions)
    ) {
      return null;
    }

    const elementWidth = elementRef.current.offsetWidth;

    // First, try to find the smallest dimension that's >= element width (prefer downscaling)
    let bestMatch = dimensionArray.find(
      (dim) => dim.dimensions.width >= elementWidth
    );

    if (bestMatch) {
      // Among dimensions >= element width, find the smallest one
      bestMatch = dimensionArray
        .filter((dim) => dim.dimensions.width >= elementWidth)
        .reduce((smallest, current) =>
          current.dimensions.width < smallest.dimensions.width
            ? current
            : smallest
        );
    } else {
      // If no dimension is >= element width, use the largest available (least upscaling)
      bestMatch = dimensionArray.reduce((largest, current) =>
        current.dimensions.width > largest.dimensions.width ? current : largest
      );
    }

    return bestMatch;
  };

  return { compress, findClosestMatch };
};
